module.exports = __webpack_public_path__ + "static/media/deviceIcon.d97fdcb7.svg";